import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text, Image } from '@chakra-ui/react';
import JsBarcode from 'jsbarcode';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../../context/appContext';
import { maskMemberCode } from './utils/maskMemberCode';

const MemberCodeCard = ({ memberCode }) => {
  const { t } = useTranslation();
  const { merchantData } = useAppContext();
  const {
    mobile_logo_media_url,
    logo_media_url,
    name = '',
  } = merchantData || {};
  const logoUrl = mobile_logo_media_url || logo_media_url;

  const generateBarcode = useCallback(
    (element) => {
      if (element && memberCode) {
        JsBarcode(element, memberCode, {
          format: 'CODE128',
          displayValue: false,
          height: 112,
          margin: 0,
        });
      }
    },
    [memberCode],
  );

  return (
    <Box width="100%" backgroundColor="#F5F5F5" color="#000">
      <Flex
        direction="column"
        alignItems="center"
        gap="12px"
        padding="24px 20px"
      >
        {logoUrl && (
          <Box
            width="37px"
            height="37px"
            borderRadius="full"
            overflow="hidden"
            flexShrink={0}
          >
            <Image
              src={logoUrl}
              alt={name}
              width="100%"
              height="100%"
              objectFit="cover"
              objectPosition="center"
            />
          </Box>
        )}
        <Text
          variant="sectionTitle"
          className="member-center-profile__section-title-text"
          color="inherit"
          fontSize="16px"
          lineHeight="normal"
          textAlign="center"
          width="100%"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {name}
        </Text>
        <Text
          variant="sectionTitle"
          className="member-center-profile__section-title-text"
          color="inherit"
          fontSize="24px"
          lineHeight="32px"
        >
          {t('member_profile.member_code.label')}
        </Text>
      </Flex>
      <Flex
        direction="column"
        alignItems="center"
        borderTopRadius="16px"
        padding="24px 0 160px"
        backgroundColor="#fff"
        color="#000"
      >
        <Box
          as="svg"
          ref={generateBarcode}
          width="320px"
          height="112px"
          preserveAspectRatio="none"
          aria-label="member code barcode"
        />
        <Text
          variant="description"
          className="member-center-profile__description-text"
          marginTop="12px"
          fontWeight="500"
          color="inherit"
        >
          {maskMemberCode(memberCode)}
        </Text>
        {['hint_line_1', 'hint_line_2'].map((key, index) => (
          <Text
            key={key}
            variant="description"
            className="member-center-profile__description-text"
            marginTop={index === 0 ? '12px' : undefined}
            paddingX="27px"
            width="100%"
            fontWeight="500"
            textAlign="center"
            color="#363D4D"
          >
            {t(`member_profile.member_code.${key}`)}
          </Text>
        ))}
      </Flex>
    </Box>
  );
};

MemberCodeCard.propTypes = {
  memberCode: PropTypes.string.isRequired,
};

export default MemberCodeCard;
